import styled from 'styled-components'

import colors from 'components/utils/colors'

import NoData from 'components/Shared/NoData/Index'

const StyledNoDataWrapper = styled.div`
  display: flex;
  height: 32px;
  width: 100%;
  border-bottom: 1px solid ${colors.secondary95};
`

const MegaMenuNoData = () => {
  return (
    <StyledNoDataWrapper>
      <NoData withIcon />
    </StyledNoDataWrapper>
  )
}

export default MegaMenuNoData
